import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import AppAeroguestComponent from '../components/AppAeroguestComponent.vue'

Vue.use(VueRouter)
const routes: Array<RouteConfig> = [
  {
    path: '/downloadapp',
    name: 'downloadapppage',
    component: () => import('@/views/DownloadAppPage.vue')

  },
  {
    path: '/termsandconditions',
    name: 'termsandconditions',
    component: () => import('@/components/policies/TermsAndConditionsComponent.vue')
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () => import('@/components/policies/PrivacyPolicyComponent.vue')
  },
  {
    path: '/confirm',
    name: 'confirm-confirmation-code',
    component: () => import('@/views/V2ConfirmPhonePage.vue')
  },
  {
    path: '/enterphone/:soMeType',
    name: 'enter-phone',
    component: () => import('@/views/EnterPhoneNumberPage.vue')
  },
  {
    path: '/support/:identifier?/:token?/',
    name: 'support',
    meta: { vaerify: true },
    component: () => import('@/components/SupportSheetComponent.vue'),
    props: true
  },
  {
    path: '/rs/qr/:chaincode/:sitecode',
    name: 'qr',
    component: () => import('@/views/sign-up/SignUpPage.vue')
  },
  {
    path: '/:identifier?/:token?/:lang?/:bookingId?',
    name: 'sign-up',
    component: () => import('@/views/sign-up/SignUpPage.vue')
  },
  { path: '*', redirect: '/' }
]
const generateRoutes = () => {
  // '192.168.1.80' for test and 'app.aeroguest.com' for prod
  if (location.hostname === 'app.aeroguest.com') {
    return [
      {
        path: '/',
        name: 'appaeroguestcomponent',
        component: AppAeroguestComponent
      }]
  } else {
    return routes
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: generateRoutes()
})

export default router
